import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { GlobalErrorHandler } from './global-error.handler';
import { HttpErrorInterceptor } from './http.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    provideErrorModule(),
  ],
})
export class ErrorModule { }

export function provideErrorModule() {
  return [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ];
}
